import { apiFetch } from './api';

// ============================================
// NEWS APIs
// ============================================

/**
 * List all news articles
 */
export function listNews(params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return apiFetch(`/api/admin/cms/news${queryString ? `?${queryString}` : ''}`);
}

/**
 * Get single news article
 */
export function getNews(id) {
  return apiFetch(`/api/admin/cms/news/${id}`);
}

/**
 * Create news article
 */
export function createNews(data) {
  return apiFetch('/api/admin/cms/news', {
    method: 'POST',
    body: data
  });
}

/**
 * Update news article
 */
export function updateNews(id, data) {
  return apiFetch(`/api/admin/cms/news/${id}`, {
    method: 'PUT',
    body: data
  });
}

/**
 * Delete news article
 */
export function deleteNews(id) {
  return apiFetch(`/api/admin/cms/news/${id}`, {
    method: 'DELETE'
  });
}

// ============================================
// EMAIL QUERIES APIs
// ============================================

/**
 * List email queries
 */
export function listEmailQueries(params = {}) {
  const queryString = new URLSearchParams(params).toString();
  return apiFetch(`/api/admin/cms/email-queries${queryString ? `?${queryString}` : ''}`);
}

/**
 * Get single email query
 */
export function getEmailQuery(id) {
  return apiFetch(`/api/admin/cms/email-queries/${id}`);
}

/**
 * Update email query
 */
export function updateEmailQuery(id, data) {
  return apiFetch(`/api/admin/cms/email-queries/${id}`, {
    method: 'PATCH',
    body: data
  });
}

/**
 * Delete email query
 */
export function deleteEmailQuery(id) {
  return apiFetch(`/api/admin/cms/email-queries/${id}`, {
    method: 'DELETE'
  });
}

/**
 * Get email query stats
 */
export function getEmailQueryStats() {
  return apiFetch('/api/admin/cms/email-queries/stats');
}

// --- Email branding & notification templates (CMS) ---

export function getEmailBranding() {
  return apiFetch('/api/admin/cms/email-branding');
}

export function putEmailBranding(data) {
  return apiFetch('/api/admin/cms/email-branding', { method: 'PUT', body: data });
}

export function listNotificationEmailTemplates() {
  return apiFetch('/api/admin/cms/notification-email-templates');
}

export function getNotificationEmailTemplate(key) {
  return apiFetch(`/api/admin/cms/notification-email-templates/${encodeURIComponent(key)}`);
}

export function putNotificationEmailTemplate(key, data) {
  return apiFetch(`/api/admin/cms/notification-email-templates/${encodeURIComponent(key)}`, {
    method: 'PUT',
    body: data
  });
}

export function patchNotificationEmailTemplateEmailEnabled(key, data) {
  return apiFetch(
    `/api/admin/cms/notification-email-templates/${encodeURIComponent(key)}/email-enabled`,
    {
      method: 'PATCH',
      body: data
    }
  );
}

export function deleteNotificationEmailTemplate(key) {
  return apiFetch(`/api/admin/cms/notification-email-templates/${encodeURIComponent(key)}`, {
    method: 'DELETE'
  });
}

export function previewNotificationEmailTemplate(body) {
  return apiFetch('/api/admin/cms/notification-email-templates/preview', {
    method: 'POST',
    body
  });
}
